<!--
 * @Descripttion: 
 * @version: 
 * @Author: gaolongzhi
 * @Date: 2020-04-10 18:43:29
 * @LastEditors: gaolongzhi
 * @LastEditTime: 2020-10-14 10:33:04
-->
<template>
  <div id="app">
    <router-view />
    <div v-if="isIndividual">
      <individual-footer v-if="$route.meta.showFooter&&$route.meta.author==undefined" class="footer"></individual-footer>
    </div>
    <div v-else>
      <job-footer v-if="$route.meta.showFooter&&$route.meta.author==undefined" class="footer"></job-footer>
      <partner-footer v-if="$route.meta.showFooter&&$route.meta.author=='partner'" class="footer"></partner-footer>
    </div>
    <job-loading class="loading"/>
  </div>
</template>

<script>
import jobFooter from "@/components/footer/footer.vue";
import partnerFooter from "@/components/footer/partnerFooter.vue";
import individualFooter from "@/components/footer/individualFooter.vue";
import jobLoading from "@/components/loading/index.vue";
import {getIndividualHeaderKey} from "./utils/auth";
export default {
  components: {
    jobFooter,
    partnerFooter,
    jobLoading,
    individualFooter
  },
  data() {
    return {
      isIndividual: false
    }
  },
  created() {
    // window.addEventListener("pageshow", function (e) {
    //   // 通过persisted属性判断是否存在 BF Cache
    //   if (e.persisted) {
    //     location.reload();
    //   }
    // });
   
    this.isIndividual = getIndividualHeaderKey();
    // 在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem('store')) {
        try{
            this.$store.replaceState(
                Object.assign(
                {},
                this.$store.state,
                JSON.parse(sessionStorage.getItem('store'))
                )
            )
        }catch{

        }

    }
 
    // 在页面刷新时将vuex里的信息保存到sessionStorage里
    // beforeunload事件在页面刷新时先触发
    window.addEventListener('beforeunload', () => {
        try{
            sessionStorage.setItem('store', JSON.stringify(this.$store.state))
        }catch{

        }
      
    })
  },
};
</script>
<style lang="less" scoped>
.footer + .loading {
  bottom: 1.6rem;
}
</style>


